import React from "react";
import { Link } from "react-router-dom";
import { PublicShell } from "@/components/shared";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <PublicShell>
      <div className="mx-auto flex max-w-lg flex-col items-center px-5 py-32 text-center">
        <p className="font-heading text-7xl font-bold text-emerald">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-navy">Page not found</h1>
        <p className="mt-2 text-slate-600">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/"><Button className="mt-6 rounded-md bg-navy text-white hover:bg-navysurface" data-testid="notfound-home">Back home</Button></Link>
      </div>
    </PublicShell>
  );
}
